const time = (iso: string) =>
  new Intl.DateTimeFormat(undefined, { timeStyle: 'short' }).format(
    new Date(iso),
  );

export const MatchFrame = ({
  courtName,
  label,
  scheduledAt,
  variant,
}: {
  courtName: string;
  label: string;
  scheduledAt: string;
  variant: 'display' | 'overlay' | 'control';
}) => {
  if (variant === 'overlay') {
    return (
      <div className="rounded-t-md bg-gradient-to-b from-blue-600 to-blue-500 px-4 py-2 text-center text-base font-semibold uppercase tracking-wider text-white">
        {label}
      </div>
    );
  }

  if (variant === 'display') {
    return (
      <div className="flex w-full justify-between px-[5vw] pt-[2vh] text-[4vh] text-slate-500">
        <span>{courtName}</span>
        <span>{label}</span>
        <span>{time(scheduledAt)}</span>
      </div>
    );
  }

  return (
    <div className="mb-6 inline-flex w-full items-center justify-center">
      <hr className="h-px w-full border-0 bg-gray-200 dark:bg-gray-700" />
      <div className="absolute inset-x-4 flex items-center justify-around">
        <span className="bg-white px-2 text-gray-500 dark:bg-gray-900 dark:text-gray-400">
          {courtName}
        </span>
        <span className="bg-white px-2 text-gray-500 dark:bg-gray-900 dark:text-gray-400">
          {label}
        </span>
        <span className="bg-white px-2 text-gray-500 dark:bg-gray-900 dark:text-gray-400">
          {time(scheduledAt)}
        </span>
      </div>
    </div>
  );
};
